export default __webpack_public_path__ + "/dist/images/connect-icon.e8bd6f539d0e203f9bc014f4c31b3a0e.svg";